import { render } from "./DownLoadTwo.vue?vue&type=template&id=6b88dafe&scoped=true"
import script from "./DownLoadTwo.vue?vue&type=script&lang=js"
export * from "./DownLoadTwo.vue?vue&type=script&lang=js"

import "./DownLoadTwo.vue?vue&type=style&index=0&id=6b88dafe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b88dafe"]])

export default __exports__